import { orderConfirmationShippingInformationStyles as styles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationShippingInformation";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { commonHeading } from "@solveindustrial/WidgetExtensions/Components/SmallHeadingAndTextExtension";
import { css } from "styled-components";

styles.shippingInformationTitle = {
    ...styles.shippingInformationTitle,
    variant: "h4",
    css: css`
        ${styles.shippingInformationTitle?.css}
        width: 100%;
        margin: 0 0 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
    `,
};

styles.shippingAddressTitle = {
    ...styles.shippingAddressTitle,
    ...commonHeading,
};
styles.shippingCarrierTitle = {
    ...styles.shippingCarrierTitle,
    ...commonHeading,
};
styles.shippingDateRequestedTitle = {
    ...styles.shippingDateRequestedTitle,
    ...commonHeading,
};
styles.shippingServiceTitle = {
    ...styles.shippingServiceTitle,
    ...commonHeading,
};
styles.shippingPoNumberTitle = {
    ...styles.shippingPoNumberTitle,
    ...commonHeading,
};
